import React from 'react'

function LikeCircleIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27.5" cy="27.5" r="27.5" fill="#FA7C00" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 38H21.8V24.2007H17V38ZM40.9142 28.0585L38.83 35.5732C38.4856 37.0001 37.1592 38 35.6317 38H24.2V24.2246L26.2625 17.0991C26.456 15.8917 27.5405 15 28.8164 15C30.2434 15 31.4001 16.1082 31.4001 17.4755V24.1998H37.7159C39.8268 24.2008 41.3899 26.0874 40.9142 28.0585Z"
        fill="white"
      />
    </svg>
  )
}

export default LikeCircleIcon
